import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    let frameId;
    let timeoutId;
    const subNavPaths = [
      '/units/mariniers',
      '/units/commandotroepen',
      '/units/luchtmobiel',
      '/units/veiligheidsdiensten',
    ];
    const isSubNav = subNavPaths.includes(pathname);

    if (hash) {
      const scrollToHash = () => {
        const id = decodeURIComponent(hash.substring(1));
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      frameId = window.requestAnimationFrame(() => {
        timeoutId = window.setTimeout(scrollToHash, 80);
      });
    } else if (isSubNav) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }

    return () => {
      if (frameId) window.cancelAnimationFrame(frameId);
      if (timeoutId) window.clearTimeout(timeoutId);
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
